import { TCategories, TGetLiferayDataResponse, TGetTierResponse } from "./types";

export const getCategoryBenefitsDataResponse = ({
  data,
}: {
  data: TGetLiferayDataResponse;
}): { title?: string; cards: TCategories } | null => {
  const categories: TCategories = {
    voebiz: [],
    essencial: [],
    prime: [],
    "super-prime": [],
    club: [],
    exclusive: [],
  };

  if (!data.items.length || !data.items[0].contentFields.length) {
    return null;
  }

  return {
    title: data.items[0].contentFields.find((field) => field.name === "title")?.contentFieldValue.data,
    cards: data.items[0].contentFields.reduce((prev, field) => {
      if (field.nestedContentFields.length) {
        let category = field.nestedContentFields.find(({ name }) => name === "type")?.contentFieldValue.data;

        let clubColor: string | undefined;

        if (category) {
          [category, clubColor] = category.split("-");

          category = category.replace(" ", "-");

          const icon = field.nestedContentFields.find(({ name }) => name === "icon")?.contentFieldValue.image;
          const title = field.nestedContentFields.find(({ name }) => name === "label")?.contentFieldValue.data;
          const description = field.nestedContentFields.find(({ name }) => name === "description")?.contentFieldValue
            .data;

          return {
            ...prev,
            [category]: [
              ...prev[category as keyof TCategories],
              { icon: { src: icon?.contentUrl, alt: icon?.description }, title, description, color: clubColor },
            ],
          };
        }
      }

      return prev;
    }, categories),
  };
};

export const getTierResponse = (result: TGetTierResponse): string | undefined => {
  return result.tierList.find((item) => {
    return item.active.toUpperCase() === "Y";
  })?.name;
};
